module.exports = __webpack_public_path__ + "img/bg_l_1_highlight.9b479044.png";